import {DeathRepo} from "../api/death.repo";
import {Injectable} from "@angular/core";
import {DuckDbHelper} from "./duckdb.helper";
import {OrgDto} from "../dto/org.dto";
import {Observable} from "rxjs";
import {WrapperDto} from "../dto/wrapper.dto";
import {DeathDto} from "../dto/death.dto";
import {SearchRequest} from "../dto/search/search-table.dto.req";
import {SearchDeathRes} from "../dto/search/search-death.res";
import {SearchFilterResponse} from "../dto/search/search-table.dto.res";

/**
 * Der Export fuehrt keine Tabelle `death`. Das Bestattungsmodul ist nie produktiv gewesen und wird es
 * nicht, deshalb ist es aus dem Exportschema entfernt worden — siehe
 * `plans/completed/iron-backup-vollstaendigkeit-plan.md`, Abschnitt 1.
 *
 * Jede Abfrage gegen `death` scheitert im Viewer mit „table does not exist". Dieses Repo antwortet
 * deshalb leer, ohne DuckDB zu fragen: Die Sterbefall-Seiten bleiben erreichbar und zeigen nichts an,
 * statt mit einem Fehler abzubrechen.
 */
@Injectable({providedIn: 'root'})
export class DeathDuckDb extends DeathRepo {

  public override getById(): Observable<WrapperDto<DeathDto>> {
    return DuckDbHelper.dataObs('DeathDto', new DeathDto());
  }

  public override search(_org: OrgDto, request: SearchRequest): Observable<WrapperDto<SearchDeathRes>> {
    const result = new SearchDeathRes({
      items: [],
      hits: 0,
      page: request.page,
      pageSize: request.pageSize,
      sortField: request.sortField,
      sortOrder: request.sortOrder,
      filters: request.filters.map((f) => new SearchFilterResponse(f))
    });
    return DuckDbHelper.dataObs('SearchDeathRes', result);
  }
}
